"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgOrders = function SvgOrders(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.596 3.274C9.17 4.55 8.509 6.706 7.568 10.217c-.941 3.512-1.446 5.711-1.716 7.027-.272 1.332.367 2.648 1.693 3.14.268.1.576.21.929.328.728.244 1.407-.1 1.81-.478a1.968 1.968 0 0 1 1.857-.467c.678.182 1.18.698 1.373 1.332.162.53.577 1.167 1.33 1.32.364.074.686.133.969.181 1.394.236 2.606-.584 3.035-1.873.425-1.275 1.087-3.432 2.028-6.944.941-3.511 1.446-5.71 1.715-7.027.273-1.331-.366-2.647-1.692-3.14-.269-.1-.577-.21-.93-.327-.728-.244-1.406.1-1.81.477a1.968 1.968 0 0 1-3.23-.865c-.161-.529-.577-1.166-1.33-1.319a29.746 29.746 0 0 0-.968-.181c-1.394-.236-2.606.584-3.035 1.873Zm-1.3-.433c.05-.156.11-.307.179-.453a1.968 1.968 0 0 1-2.63-.058c-.404-.378-1.083-.722-1.811-.478a29.65 29.65 0 0 0-.93.327C1.78 2.673 1.14 3.988 1.412 5.32c.27 1.317.774 3.516 1.715 7.028l.239.883c.232.854.446 1.619.642 2.303l.002.008c.17.59.325 1.122.468 1.597l.031-.169c.277-1.35.789-3.577 1.735-7.106.946-3.53 1.615-5.715 2.051-7.022Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgOrders);
var _default = exports["default"] = Memo;